import {COMPANIES_LOAD_SUCCESS, COMPANIES_UPDATED} from "../config/actions";

export function setCompanies(companies) {
    return {
        type: COMPANIES_LOAD_SUCCESS,
        companies
    }
}

export function companiesUpdated() {
    return {
        type: COMPANIES_UPDATED
    }
}
